var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon)?_c('v-icon',{attrs:{"color":_vm.icon.color}},[_vm._v(" "+_vm._s(_vm.icon.name)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }